const nameof = <T>(name: Extract<keyof T, string>): string => name;

class BadRequestError extends Error {
  constructor(message?: string) {
    super(message);
  }
}

export { BadRequestError, nameof };
